 <app-pagetitle title="{{nameApp}}" [breadcrumbItems]="breadCrumbItems"></app-pagetitle> 

<div class="row">
    <div class="col-sm-12">
        <div class="card card-border">
            <div class="card-header">
                <div class="row">
                </div>
            </div>

            <div class="container card-body table-responsive">

                <div class="container card-body mb-2 table-responsive "
                    style="background-color: #f2f3f4; border-radius:20px; border:1px solid  #d3d4d6;box-shadow: 2px 2px 5px #999 ">

                    <div class="form-group row mb-2">
                        <div class="col col-md-2">
                            <b><h3 style="text-align:right; display:block;">MISIÓN:</h3></b>
                        </div>
                        <div class="col col-md-10">
                            <p style="text-align: justify">{{mision}}</p>
                        </div>
                    </div>
                </div>
                <div class="container card-body mb-2 table-responsive pt-3 "
                    style="background-color: #f2f3f4; border-radius:20px; border:1px solid  #d3d4d6;box-shadow: 2px 2px 5px #999 ">

                    <div class="form-group row mb-2">
                        <div class="col col-md-2">
                            <b><h3 style="text-align:right; display:block">VISIÓN:</h3></b>
                        </div>
                        <div class="col col-md-10">
                            <p style="text-align: justify">{{vision}}</p>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</div>